import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <div className="tl  pa2 pa4-ns bg-light-green black">
        <h1 className="f4 fw6 f1-ns lh-title measure mt0 mb0">
          Search
        </h1>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js